import axios from "axios";
import { IScreeningInfo } from "../types/screening.types";
import { api } from "./api";

export type screeningKeys =
  | "humanResources"
  | "agriculture"
  | "conclusion"
  | "landFund"
  | "smbDevelopment"
  | "swotAnalysis";

export const getScreening = (
  kato: number,
  year: number = 2024
): Promise<IScreeningInfo> => {
  return api
    .get(`/public/screening?kato=${kato}&year=${year}`)
    .then((res) => res.data.data);
};

export const updateScreening = (
  kato: number,
  key: screeningKeys,
  data: any,
  year: number = 2025
) => {
  return api
    .post(
      `/supervisor/screening/update?kato=${kato}&key=${key}&year=${year}`,
      data
    )
    .then((res) => res.data);
};

export const downloadScreeningReport = () => {
  return api
    .get(`/supervisor/kato/report/download`, {
      responseType: "arraybuffer",
    })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "filling_stats.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
};
